/**
 * LLM が生成した tool input が schema は満たすものの意味的に不正なときに投げる。
 *
 * message は model にそのまま返り、次の step で入力を修正する手がかりになる。
 * アプリ側の不具合ではなく model の入力誤りなので、Bugsnag 通知ではなく breadcrumb
 * として記録する。
 */
export class ToolInputError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ToolInputError";
  }

  static isInstance(error: unknown): error is ToolInputError {
    return error instanceof ToolInputError;
  }
}
